module.exports = __webpack_public_path__ + "static/media/safe.5d1c9b59.svg";